import { NewButton, NewButtonVariant } from "@visiblethread/react-components";
import { Download } from "lucide-react";
import { useSelector } from "react-redux";
import {
  selectCoverage,
  selectOutlineDocuments,
  selectOutlineOwnerName,
  selectRequirements,
} from "slices/proposalOutline/selectors";

import { buildDocumentLabelsById } from "../gates/requirementsReviewColumns";
import {
  buildRequirementsCsv,
  downloadRequirementsCsv,
} from "../requirementsCsv";

const ExportRequirementsButton = () => {
  const coverage = useSelector(selectCoverage);
  const requirements = useSelector(selectRequirements);
  const ownerName = useSelector(selectOutlineOwnerName);
  const outlineDocuments = useSelector(selectOutlineDocuments);

  const exportCsv = () => {
    const labelsById = buildDocumentLabelsById(outlineDocuments);
    const csv = buildRequirementsCsv(requirements, coverage, labelsById);

    downloadRequirementsCsv(csv, ownerName);
  };

  const hasNoRequirements = requirements.length === 0;

  return (
    <NewButton
      disabled={hasNoRequirements}
      leftIcon={<Download size={14} aria-hidden />}
      onClick={exportCsv}
      title={hasNoRequirements ? "No requirements to export" : undefined}
      variant={NewButtonVariant.l2}
    >
      Export to CSV
    </NewButton>
  );
};

export default ExportRequirementsButton;
